import { createSelector } from 'reselect';

import { ClessonResultsStoreState, ReduxClessonResultsStore } from './typings';

const storeSelector = (storeState: ReduxClessonResultsStore): ClessonResultsStoreState => storeState.clessonResults;

export const getClessonResults = createSelector(storeSelector, (store) => store.items);

export const getClessonsCriteriaMarks = createSelector(storeSelector, (store) => store.criteriaMarks);
